import "core-js/modules/es6.regexp.search";
/* eslint-disable */
/* 导航按钮组件
 * <component-navigation-btn type="1" title="详情" :is-hide="!paused" v-if="isOtherBrowser"></component-navigation-btn>
 * type: 1.商详页顶部导航栏  2.轮播图导航    3.其它页面(非商详酒景门店页)顶部导航栏   4.酒景页、门店页顶部导航栏
 * :is-hide: 轮播图播放视频时需要隐藏导航模块
 */
import { isByteDanceMiniProgram, goToHome } from '@ykz/ykz-util/platform';
export default {
  name: 'navigationBtn',
  data: function data() {
    return {
      weChatId: getUrlParams('weChatId') || window.weChatId,
      showNavigation: true,
      //显示导航栏，默认true
      showMenu: false,
      //显示菜单
      offsetY: 0,
      //导航栏的Y轴偏移量
      isScenicDetail: location.href.search(/goodsDetails|storeDetails/) != -1 //是否是酒景（门店）页
    };
  },

  props: ['type', 'title', 'isHide'],
  mounted: function mounted() {
    //typeof window.componentCenter == 'object' || (window.componentCenter = {});
    console.log('ycf组件初始化：navigationBtn');
    var isByteDance = isByteDanceMiniProgram();
    if (isByteDance) {
      this.showNavigation = false;
    } else if (this.type == 4) {
      this.showNavigation = false;
      this.pageScrollChange();
    }
  },
  methods: {
    //通用锚点事件
    generalAnchors: function generalAnchors(element_content, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: '540022',
        properties: {
          element_content: element_content
        }
      }).always(callback);
    },
    //返回上一页
    goBack: function goBack() {
      this.generalAnchors('clickReturn', function () {
        history.back();
      });
    },
    //跳转到商城首页或订单中心页
    goPage: function goPage(type) {
      var that = this;
      if (type == 1) {
        this.generalAnchors('clickGoodsMall');
        // window.location.href =
        //   '/front/promoter/shoppingMallv2?weChatId=' + that.weChatId
        var url = '/front/promoter/shoppingMallv2?weChatId=' + that.weChatId;
        goToHome(url);
      } else {
        this.generalAnchors('clickMyOrder', function () {
          window.location.href = '/front/userCenter/orderlist?weChatId=' + that.weChatId + '&bookFrom=' + (that.isScenicDetail ? 'scenicDetail' : 'itemDetail');
        });
      }
    },
    //酒景页、门店页顶部导航栏，页面滚动变化
    pageScrollChange: function pageScrollChange() {
      var that = this,
        topBarHeight = $('.component-navigation-btn.is-bar').height(),
        //顶部固定栏的高度
        topBarOffsetY = 0; //顶部固定栏未固定以前，到顶部的距离
      $('#app').scroll(function () {
        var scrollTop = this.scrollTop;
        topBarOffsetY = $('#swiper')[0].offsetTop + $('#swiper').height();
        if (scrollTop >= topBarOffsetY - 2 * topBarHeight) {
          that.showNavigation = true;
          that.offsetY = scrollTop - topBarOffsetY + topBarHeight;
          that.offsetY > 0 && (that.offsetY = 0);
          $('.component-navigation-btn.is-bar').css('transform', 'translateY(' + that.offsetY + 'px)');
        } else {
          that.showNavigation = false;
        }
      });
    }
  }
};